(function () {
  if (window.__pcbUpcartInjectorInit) return;
  window.__pcbUpcartInjectorInit = true;

  // Inject PCB ABOVE this element inside the Upcart drawer.
  // Target both the stable class (.upcart-cart-body) and the hashed CSS-modules class
  // (styles_CartPreview__body__*). Whichever appears first wins.
  var ANCHOR_SELECTORS = [
    '.upcart-cart-body',
    '[class*="styles_CartPreview__body" i]',
    '[class*="CartPreview__body" i]'
  ];

  function getCartHost() {
    return document.getElementById('pcb-cart-host');
  }

  function getCartPCB() {
    return document.querySelector('progressive-coupon-bar.pcb--cart');
  }

  function findAnchor() {
    for (var i = 0; i < ANCHOR_SELECTORS.length; i++) {
      var el = document.querySelector(ANCHOR_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function moveBackToHost() {
    var pcb = getCartPCB();
    var host = getCartHost();
    if (pcb && host && pcb.parentNode !== host) {
      host.appendChild(pcb);
    }
  }

  function inject() {
    var anchor = findAnchor();
    if (!anchor || !anchor.parentNode) return false;
    var pcb = getCartPCB();
    if (!pcb) return false;
    if (pcb.nextElementSibling === anchor) return true;
    anchor.parentNode.insertBefore(pcb, anchor);
    return true;
  }

  var observer = new MutationObserver(function () {
    if (!inject()) {
      var anchor = findAnchor();
      if (!anchor) moveBackToHost();
    }
  });

  function start() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    inject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
